import { Link } from "react-router-dom";
import { articles, hotKeywords } from "@/mocks/articles";
import { usePageMeta } from "@/hooks/usePageMeta";
import ArticleCard from "@/components/base/ArticleCard";
import SectionHeading from "@/components/base/SectionHeading";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import HotList from "@/pages/home/components/HotList";
import SiteIntro from "@/pages/home/components/SiteIntro";

const sortedByTime = [...articles].sort(
  (a, b) => new Date(b.publishTime).getTime() - new Date(a.publishTime).getTime(),
);
const sortedByHot = [...articles].sort((a, b) => b.views - a.views);

export default function Home() {
  usePageMeta({
    title: "吃瓜网站-最新娱乐八卦热点与资讯分享平台",
    description:
      "吃瓜网站提供丰富的娱乐新闻、热点八卦和趣闻资讯，涵盖明星动态、影视评论、网红事件等，让用户及时了解最新娱乐圈动态。",
    keywords: "吃瓜网站,娱乐新闻,八卦热点,明星动态,影视评论,娱乐资讯,网红事件,趣闻分享",
  });

  const featured = sortedByTime.slice(0, 3);
  const latest = sortedByTime.slice(0, 8);
  const hot = sortedByHot.slice(0, 8);

  return (
    <div className="w-full">
      <h1 className="sr-only">吃瓜网站 - 最新娱乐八卦热点与资讯分享平台</h1>

      <HeroCarousel items={featured} />

      <CategoryGrid articles={articles} />

      <section className="w-full px-4 md:px-6 pb-4">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-10">
          <div className="lg:col-span-2">
            <SectionHeading
              icon="ri-newspaper-line"
              title="最新资讯"
              subtitle="按发布时间倒序，实时更新"
              accent="primary"
              action={
                <Link
                  to="/category/star"
                  className="hidden sm:inline-flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-600 whitespace-nowrap transition-colors"
                >
                  更多
                  <i className="ri-arrow-right-s-line" />
                </Link>
              }
            />
            <div className="space-y-3 md:space-y-4">
              {latest.map((a) => (
                <ArticleCard key={a.id} article={a} />
              ))}
            </div>
          </div>

          <aside className="lg:col-span-1 space-y-6">
            <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
              <SectionHeading icon="ri-fire-line" title="热门榜单" subtitle="按阅读量排序" accent="accent" />
              <HotList items={hot} />
            </div>

            <div className="rounded-lg border border-background-200 bg-secondary-50 p-4 md:p-5">
              <SectionHeading icon="ri-hashtag" title="热点关键词" accent="secondary" />
              <div className="flex flex-wrap gap-2">
                {hotKeywords.map((w) => (
                  <Link
                    key={w}
                    to={`/search?q=${encodeURIComponent(w)}`}
                    className="px-3 py-1.5 rounded-full bg-background-50 border border-secondary-200 text-xs md:text-sm text-secondary-900 hover:bg-secondary-500 hover:text-background-50 hover:border-secondary-500 whitespace-nowrap transition-colors"
                  >
                    #{w}
                  </Link>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </section>

      <SiteIntro />
    </div>
  );
}